/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack, Divider, alpha } from '@mui/material';
// mock
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { fr } from 'date-fns/locale';
import { format } from 'date-fns';
import account from '../../_mock/account';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
//
import navConfig from './NavConfig';
import Iconify from '../../components/Iconify';
import NavSectionMetrics from '../../components/navSectionMetrics';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 260;

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
        width: DRAWER_WIDTH,
    },
}));


// ----------------------------------------------------------------------

DashboardSidebarV2.propTypes = {
    isOpenSidebar: PropTypes.bool,
    onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebarV2({ isOpenSidebar, onCloseSidebar, eventImage, eventName, status, visibility, date, seance }) {
    const { pathname } = useLocation();

    const isDesktop = useResponsive('up', 'lg');

    const handleTimestamp = (e) => {
        const date = e.toDate();
        const tmp = date.toJSON().split('.');
        const t = tmp[0].split('T');
        return date;
    };

    useEffect(() => {
        if (isOpenSidebar) {
            onCloseSidebar();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    const content = (
        <Scrollbar>
            <Box sx={{ px: 1, py: 1, }}>
                <Stack
                    direction="column"
                    spacing={1}
                    sx={{
                        borderRadius: '7px',
                        width: '100%',
                        bgcolor: alpha('#5E17EB', 0.08),
                    }}
                >
                    <Box sx={{ width: '100%', borderRadius: '7px' }}>
                        <LazyLoadImage
                            src={`${eventImage}`}
                            alt={`${eventName}`}
                            className="img-lazy"
                            width="100%"
                            height={100}
                            style={{ objectFit: 'cover', borderTopLeftRadius: '7px', borderTopRightRadius: '7px' }}
                            effect="blur" // opacity | black-and-white
                        />
                    </Box>

                    <Stack spacing={0.25} paddingX={2} paddingBottom={1}>
                        <Typography variant='body1' fontWeight={550}>{eventName}</Typography>
                        {
                            seance === 1 ?
                                <Typography fontSize={14}>Plusieurs dates</Typography>
                                : <Typography fontSize={14}>{date ? format(new Date(handleTimestamp(date)), 'EEE dd MMM yyyy HH:mm', { locale: fr }) : null}</Typography>
                        }

                        <Stack direction='row' spacing={1}>

                            {
                                status === 3 ?
                                    <Box
                                        padding={0.25}
                                        width={90}
                                        sx={{ bgcolor: '#f2f2f2', borderRadius: '10px', paddingY: 0.5, paddingX: 1, fontSize: 10 }}
                                    >
                                        <Stack direction='row' spacing={1} alignItems='center'>
                                            <Iconify icon='material-symbols:lock' sx={{ height: 15, width: 15 }} />
                                            <Typography variant='caption'>Privé</Typography>
                                        </Stack>
                                    </Box>
                                    :
                                    <>
                                        {
                                            visibility === 1 ?
                                                <Box
                                                    padding={0.25}
                                                    width={90}
                                                    sx={{ bgcolor: '#f2f2f2', borderRadius: '10px', paddingY: 0.5, paddingX: 1, fontSize: 10 }}
                                                >
                                                    <Stack direction='row' spacing={1} alignItems='center'>
                                                        <Iconify icon='mdi:lock' sx={{ height: 15, width: 15 }} />
                                                        <Typography variant='caption'>Privé</Typography>
                                                    </Stack>
                                                </Box>
                                                :
                                                <Box
                                                    padding={0.25}
                                                    width={90}
                                                    sx={{ bgcolor: '#f2f2f2', borderRadius: '10px', paddingY: 0.5, paddingX: 1, fontSize: 10 }}
                                                >
                                                    <Stack direction='row' spacing={1} alignItems='center'>
                                                        <Iconify icon='ic:outline-public' sx={{ height: 15, width: 15 }} />
                                                        <Typography variant='caption'>Public</Typography>
                                                    </Stack>
                                                </Box>
                                        }
                                    </>


                            }

                        </Stack>
                    </Stack>
                </Stack>
            </Box>


            <NavSectionMetrics navConfig={navConfig} onCloseSidebar={onCloseSidebar} isDesktop={isDesktop} />
            <Box flexGrow={1} />
        </Scrollbar>
    );

    return (
        <RootStyle>
            <Drawer
                open={isDesktop || isOpenSidebar}
                onClose={onCloseSidebar}
                variant={isDesktop ? 'persistent' : 'temporary'}
                PaperProps={{
                    sx: {
                        width: DRAWER_WIDTH,
                        borderRight: '1px solid #eee',
                    },
                }}
            >
                {content}
            </Drawer>
        </RootStyle>

    );
}
